import Footer from "../components/footer/footer"
import General from "../components/termsAndConditions/general";
import AIteensTerms from "../components/termsAndConditions/aiTeens";
import AIprofTerms from "../components/termsAndConditions/aiProf";
import AIsmallBusinessTerms from "../components/termsAndConditions/aiSmallBusiness";

export default function TermsConditions() {
  return (
    <>
      <General />
      <AIteensTerms />
      <AIprofTerms />
      <AIsmallBusinessTerms />
      <Footer />
    </>
  );
}